import React, { useState } from 'react';
// import { Modal } from "antd";
import FeatherIcon from 'feather-icons-react';

import { Button } from '../../../../../components/buttons/buttons';
import { Modal } from 'antd';
import { Form } from '../ContactForm';

interface ITableButtonEditProps {
  interationId: string;
  refetch: () => void;
  data: IFetchProps;
}

interface IFetchProps {
  title: string;
  content: string;
  faq_category_id: string;
}

export function TableButtonEdit({ interationId, refetch, data }: ITableButtonEditProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button className="btn-icon" type="info" onClick={() => setModalIsOpen(true)} to="#" shape="circle">
        <FeatherIcon icon="edit" size={16} />
      </Button>

      <Modal
        title="Editar Faq"
        visible={modalIsOpen}
        onCancel={() => setModalIsOpen(false)}
        confirmLoading={true}
        footer={null}
        maskClosable={false}
        width={600}
        style={{ marginTop: -60 }}
        bodyStyle={{ padding: 0 }}
      >
        <Form
          formType="put"
          interationId={interationId}
          initialFields={{
            title: data.title,
            content: data.content,
            content_en: '',
            title_en: '',
            faq_category_id: data.faq_category_id,
          }}
          setModalIsOpen={setModalIsOpen}
          refetch={refetch}
        />
      </Modal>
    </>
  );
}
